import {useDispatch, useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {startRegistrationFlowForCurrentUser} from "../../auth/actions/start_registration_flow_for_current_user";
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {RegistrationWizardAccountEntry} from "../../auth/types/RegistrationWizardEntry";
import {IAppDispatch} from "../../store/store";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";

export interface IFavoriteAuthParams {
    type: "property" | "offer";
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export const useFavoritesAuth = () => {
    const dispatch = useDispatch<IAppDispatch>();
    const propertyDetail = useSelector((store: IRPStore) => store.property);

    const auth = (params: IFavoriteAuthParams) => {
        dispatch(
            startRegistrationFlowForCurrentUser({
                userSource: params.type === "property" ? UserSource.FAVOURITE_PROPERTY : UserSource.FAVOURITE_OFFER,
                gtmSourceSection: GTMEventApplicationSourceSection.FAVOURITE_BUTTON,
                modalVariant: "hidden_prices_variant_b",
                propertyId: propertyDetail.property?.id ?? undefined,
                offerId: propertyDetail.property?.offer.id ?? undefined,
                titleVariant: AuthModalVariant.FAVORITE,
                amplitudePlacement: params.amplitudePlacement,
                wizardEntry: RegistrationWizardAccountEntry.FAVOURITE
            })
        );
    };

    return auth;
};
import {useDispatch, useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {startRegistrationFlowForCurrentUser} from "../../auth/actions/start_registration_flow_for_current_user";
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {RegistrationWizardAccountEntry} from "../../auth/types/RegistrationWizardEntry";
import {IAppDispatch} from "../../store/store";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";

export interface IFavoriteAuthParams {
    type: "property" | "offer";
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export const useFavoritesAuth = () => {
    const dispatch = useDispatch<IAppDispatch>();
    const propertyDetail = useSelector((store: IRPStore) => store.property);

    const auth = (params: IFavoriteAuthParams) => {
        dispatch(
            startRegistrationFlowForCurrentUser({
                userSource: params.type === "property" ? UserSource.FAVOURITE_PROPERTY : UserSource.FAVOURITE_OFFER,
                gtmSourceSection: GTMEventApplicationSourceSection.FAVOURITE_BUTTON,
                modalVariant: "hidden_prices_variant_b",
                propertyId: propertyDetail.property?.id ?? undefined,
                offerId: propertyDetail.property?.offer.id ?? undefined,
                titleVariant: AuthModalVariant.FAVORITE,
                amplitudePlacement: params.amplitudePlacement,
                wizardEntry: RegistrationWizardAccountEntry.FAVOURITE
            })
        );
    };

    return auth;
};
